import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, NavLink, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import './components/styles.css';

const Home = lazy(() => import('./components/Home'));
const Courses = lazy(() => import('./components/Courses'));
const Research = lazy(() => import('./components/Research'));
const HPC25 = lazy(() => import('./components/HPC25'));
const CA25 = lazy(() => import('./components/CA25'));
const CA26 = lazy(() => import('./components/CA26'));
const HPCM26 = lazy(() => import('./components/HPCM26'));
const FDFEDM26 = lazy(() => import('./components/FDFEDM26'));
const Team = lazy(() => import('./components/Team'));
const Presentations = lazy(() => import('./components/Presentations'));
const Resources = lazy(() => import('./components/Resources'));
const WorkshopsOrganized = lazy(() => import('./components/WorkshopsOrganized'));
const ViewFile = lazy(() => import('./components/ViewFile'));
const Gcctranl = lazy(() => import('./components/Gcctranl'));
const SessionList = lazy(() => import('./components/SessionList'));
const VideoPopup = lazy(() => import('./components/VideoPopup'));
const PdfPopup = lazy(() => import('./components/PdfPopup'));
const HPC26 = lazy(() => import('./components/HPC26'));
const FDFED25 = lazy(() => import('./components/FDFED25'));
const ReactPuzzle = lazy(() => import('./components/PuzzleQuestions'));
const TreeCarbon = lazy(() => import('./components/TreeCarbon'));
const HooksTutorial = lazy(() => import('./components/HooksTutorial'));
const OpenFile = lazy(() => import('./components/Open_file'));
const IIITForum = lazy(() => import('./components/IIITForum'));

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/Courses', label: 'Courses' },
  { to: '/Research', label: 'Research' },
  { to: '/WorkshopsOrganized', label: 'Workshops Organized' },
  { to: '/Resources', label: 'Resources' },
  { to: '/Presentations', label: 'Publications' },
];

function AppLayout() {
  const location = useLocation();
  const isForumRoute = location.pathname === '/IIITForum' || location.pathname === '/IIITPPForum';

  return (
    <div className={`container app-shell${isForumRoute ? ' forum-shell' : ''}`}>
      {!isForumRoute && (
        <nav className="site-nav" aria-label="Main navigation">
          <ul>
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink to={item.to}>{item.label}</NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}

      <main className={`page-content${isForumRoute ? ' forum-page-content' : ''}`}>
        <Suspense fallback={<div className="route-loader">Loading page...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Courses" element={<Courses />} />
            <Route path="/Research" element={<Research />} />
            <Route path="/HPC25" element={<HPC25 />} />
            <Route path="/Gcctranl" element={<Gcctranl />} />
            <Route path="/HPC26" element={<HPC26 />} />
            <Route path="/FDFED25" element={<FDFED25 />} />
            <Route path="/CA25" element={<CA25 />} />
            <Route path="/CA26" element={<CA26 />} />
            <Route path="/HPCM26" element={<HPCM26 />} />
            <Route path="/FDFEDM26" element={<FDFEDM26 />} />
            <Route path="/Presentations" element={<Presentations />} />
            <Route path="/WorkshopsOrganized" element={<WorkshopsOrganized />} />
            <Route path="/Resources" element={<Resources />} />
            <Route path="/Team" element={<Team />} />
            <Route path="/viewfile/:filename" element={<ViewFile />} />
            <Route path="/SessionList" element={<SessionList />} />
            <Route path="/React_Puzzle" element={<ReactPuzzle />} />
            <Route path="/TreeCarbon" element={<TreeCarbon />} />
            <Route path="/video/:id" element={<VideoPopup />} />
            <Route path="/pdf/:id" element={<PdfPopup />} />
            <Route path="/HooksTutorial" element={<HooksTutorial />} />
            <Route path="/Open_file" element={<OpenFile />} />
            <Route path="/IIITForum" element={<IIITForum />} />
            <Route path="/IIITPPForum" element={<IIITForum />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
      </main>

      {!isForumRoute && (
        <footer className="site-footer">
          <p>
            <a href="http://www.iiits.in">IIIT Sri City</a> | CSE
          </p>
        </footer>
      )}

      {!isForumRoute && (
        <a className="flag-counter" href="http://s11.flagcounter.com/more/NJrX">
          <img
            src="https://s11.flagcounter.com/count/NJrX/bg_FFFFFF/txt_000000/border_CCCCCC/columns_1/maxflags_1/viewers_3/labels_0/pageviews_1/flags_0/percent_1/"
            alt="Flag Counter"
            loading="lazy"
          />
        </a>
      )}
    </div>
  );
}

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppLayout />
    </Router>
  );
}

export default App;